import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import imports from "../../../../assets/images/rpHomePage/4022440.jpg";
import settings from "../../../../assets/images/settings.png"
import vra from "../../../../assets/images/rpHomePage/vra.png";
import vra2 from "../../../../assets/images/rpHomePage/vra2.jpg";
import caoch from "../../../../assets/images/rpHomePage/8294.jpg";
import report from "../../../../assets/images/rpHomePage/313.jpg";
import affinity from "../../../../assets/images/rpHomePage/aff.png"
import atc from "../../../../assets/images/rpHomePage/atc.jpg"
import poolprep from "../../../../assets/images/rpHomePage/poolprep.jpg"
import poolprep2 from "../../../../assets/images/rpHomePage/poolprep2.jpg"
import pooling from "../../../../assets/images/rpHomePage/poolingImage.jpg"
import "./RpHome.css";
import substitution from "../../../../assets/images/rpHomePage/substitution.png";
import QualityDashboard from "../../../../assets/images/qualitydashboard.webp";
import PoolImg from "assets/images/rpHomePage/rp-homepage-pool.png"
import { Fragment, useContext, useEffect, useState } from 'react';
import Context from "context/context";
import qualitysettings from "../../../../assets/images/qualitysettings.png";

const RpHomePage = () => {
  const { state } = useContext(Context);
  const navigate = useNavigate();

  const [obj, setObj] = useState({})

    const handlevraRosterNavigate = () => navigate("/panel/vraRoster");
    const handleCard1Navigate = () => navigate("/panel/radRoster");
    const handleCard2Navigate = () => navigate("/panel/importsrf");
    const handleCard3Navigate = () => navigate("/panel/rpreports");
    const handleCard4Navigate = () => navigate("/panel/trainingsetup");

    const handlePoolPrepNavigate = () => navigate("/panel/poolPrepRoster");
    const handleAtcNavigate = () => navigate("/panel/atcRoster");
    const handleCardQgendaNavigate = () => navigate("/panel/qagenda");
    const handleAffinityNavigate=()=> navigate("/panel/vraRadAffinity");
    const handleCardVRASchedulingNavigate=()=> navigate("/panel/settings");
    const handleVraSubstitutions=()=> navigate("/panel/vraSubstitutions")
    const handleQualityImport=()=>navigate("/panel/ImportQualityData")
    const handleQualityDashboard = ()=>navigate("/panel/qualityDashboard")
    const handlePoolingNavigate=()=> navigate("/panel/VraRadPool");
    const handleQualitySettings=()=>navigate("/panel/QualitySettings")

const handleAssignObject = (roleCode) =>{


   const findAccess = (key) =>{
        if((roleCode === "R008" || roleCode === "R009" || roleCode === "R012" || roleCode === "R013") && (key === "H4" || key === "H4C1")){
             return true
        }
        if(roleCode === "R004" || roleCode === "R010"){
            return true
       }
       if(roleCode === "R001" || roleCode === "R011"){
        return true
   }
        return false
    }

    const obj = {
        "Roster Management":{access: findAccess("H1"),key:"H1",
         arr:[
             {
                 access:findAccess("H1C1"),
                 name:"RAD Roster",
                 image:vra2,
                 onClick: handleCard1Navigate,
                 key:"H1C1"
             },
             {
                 access:findAccess("H1C2"),
                 name:"VRA Roster",
                 image:vra,
                 onClick: handlevraRosterNavigate,
                 key:"H1C2"
             },
             {
                 access:findAccess("H1C3"),
                 name:"Affinity Roster",
                 image:affinity,
                 onClick: handleAffinityNavigate,
                 key:"H1C3"
             },
             {
                 access:findAccess("H1C4"),
                 name:"VRA RAD Pool Roster",
                 image:PoolImg,
                 onClick: handlePoolingNavigate,
                 key:"H1C4"
             },
              {
                 access:findAccess("H1C1"),
                 name:"Pool Prep Roster",
                 image:poolprep2,
                 onClick: handlePoolPrepNavigate,
                 key:"H1C1"
             },
             {
                 access:findAccess("H1C1"),
                 name:"ATC Roster",
                 image:atc,
                 onClick: handleAtcNavigate,
                 key:"H1C1"
             },
         ]
        }, 
        "Schedule Data Management":{access: findAccess("H2"),key:"H2",
         arr:[
             {
                 access:findAccess("H2C1"),
                 name:"Import SRF Data",
                 image: imports,
                 onClick: handleCard2Navigate,
                 key:"H2C1"
             },
             {
                 access:findAccess("H2C2"),
                 name:"Import Qgenda Data",
                 image: imports,
                 onClick: handleCardQgendaNavigate,
                 key:"H2C2"
             },
             {
                 access:findAccess("H2C3"),
                 name:"VRA Substitutions",
                 image: substitution,
                 onClick: handleVraSubstitutions,
                 key:"H2C3"
             }
         ]
        }, 
        "Reports and Settings":{access: findAccess("H3"),key:"H3",
         arr:[
             {
                 access:findAccess("H3C1"),
                 name:"Reports",
                 image: report,
                 onClick: handleCard3Navigate,
                 key:"H3C1"
             },
             {
                 access:findAccess("H3C2"),
                 name:"Settings",
                 image:settings,
                 onClick: handleCardVRASchedulingNavigate,
                 key:"H3C2"
             }
         ]
        }, 
        "Quality":{access: findAccess("H4"),key:"H4",
         arr:[
             {
                 access:findAccess("H4C1"),
                 name:"Quality Dashboard",
                 image: QualityDashboard,
                 onClick: handleQualityDashboard,
                 key:"H4C1"
             },
             {
                 access:findAccess("H4C2"),
                 name:"Import Quality Data",
                 image:imports,
                 onClick: handleQualityImport,
                 key:"H4C2"
             },
             {
                access:findAccess("H4C2"),
                name:"Quality Settings",
                image:qualitysettings,
                onClick: handleQualitySettings,
                key:"H4C2"
            }
         ]
        }, 
        "Training Management":{access: findAccess("H5"),key:"H5",
         arr:[
             {
                 access:findAccess("H5C1"),
                 name:"Training Setup",
                 image:caoch,
                 onClick: handleCard4Navigate,
                 key:"H5C1"
             }
         ]
        }, 
     }

    setObj(obj)
     
}

useEffect(()=>{
if(state?.role?.roleCode){
    handleAssignObject(state?.role?.roleCode)
}
},[state.role])

    return (
        <div style={{
            backgroundColor: "white",
            borderRadius: "10px",
            minHeight: "100vh"
        }}>
            {
                Object.keys(obj)?.map(o=>(
                    <Fragment>
           {obj[o]?.access &&( 
                    <Fragment>
            
            <Box sx={{ pt: 2, pb: 2, pl: 3 }} className="VraShiftsTitle">{o}</Box>
            <Grid container spacing={2} sx={{ p: 1 }}>
                {
                    obj[o]?.arr?.filter(f=>f.access=== true)?.map(arr=>

                        <Grid item xs={12} md={4}>
                        <Card onClick={arr?.onClick}>
                            <CardActionArea sx={{ display: 'flex', flexDirection: 'column' }}>
                                <CardMedia
                                    component="img"
                                    image={arr?.image}
                                    alt={arr?.name}
                                    sx={{
                                        height: '200px',
                                        width: '100%',
                                        objectFit: 'contain',
                                        borderTopLeftRadius: 4,
                                        borderTopRightRadius: 4
                                    }}
                                />
                                <CardContent>
                                    <div  className='CardContentTitle'>
                                        {arr.name}
                                    </div>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    )
                }
                </Grid>
                </Fragment>
            
            )}
                </Fragment>
                )
                )
            }


         
        </div>
    );
};

export default RpHomePage;
